import { Button, buttonClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Button)`
    &.${buttonClasses.root} {
        text-transform: unset;
        padding: 10px 24px;
        font-weight: 600;
        line-height: 1.15;
    }
`;
